import { Question } from '@verzekeringapp-mono/shared/src/models/value_meter_question'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

const useCalculation = (watch: ReturnType<typeof useFormContext>['watch']) =>
  useCallback((question: Question) => {
    if (!question.calculation?.length) return 0

    let total = 0

    for (const fieldName of question.calculation) {
      const raw = watch(fieldName)
      const value = Number(raw)

      if (Number.isNaN(value)) {
        // Skip non-numeric values
        continue
      }

      total += value
    }

    return total
  }, [watch])

export default useCalculation
